import axios from 'axios';

export type LockboxPortalAssociation = {
  id: string;
  lockboxVendorSettings: {
    supra: boolean;
    sentriLock: boolean;
    masterLock: boolean;
    combinationLockbox: boolean;
  } | null;
};

const getLockboxPortalSettings = async (onboardingPortalId: string) => {
  const { data } = await axios.get<LockboxPortalAssociation[]>(
    `/lockbox/portal-lockbox-settings`,
    { params: { onboardingPortalId } },
  );
  return data;
};

export default getLockboxPortalSettings;
